/**
 * Utility functions for handling PDF files
 */

/**
 * Opens a PDF file in a new window or tab
 * @param {string} pdfPath - Path to the PDF file
 */
export const openPdfInNewWindow = (pdfPath) => {
  if (!pdfPath) return;
  
  // Make sure the path is absolute with domain
  const absolutePath = pdfPath.startsWith('http') 
    ? pdfPath 
    : window.location.origin + pdfPath;
  
  window.open(absolutePath, '_blank');
};

/**
 * Determines if a file exists at the specified path
 * This is a simple check that doesn't actually verify if the file exists
 * on the server, but rather checks if the path is valid
 * 
 * @param {string} filePath - Path to check
 * @returns {boolean} True if the path is valid, false otherwise
 */
export const doesFileExist = (filePath) => {
  if (!filePath) return false;
  
  // PDF files should have a valid path
  const isValidPath = filePath.endsWith('.pdf') || 
                     filePath.endsWith('.PDF') ||
                     filePath.includes('/pdf/') ||
                     filePath.includes('/documents/');
  
  return isValidPath;
};

/**
 * Returns the file name from a path
 * @param {string} filePath - Full path to the file
 * @returns {string} File name
 */
export const getFileNameFromPath = (filePath) => {
  if (!filePath) return '';
  
  // Extract filename from path
  const parts = filePath.split('/');
  return parts[parts.length - 1];
};

/**
 * Returns the exhibit ID from a filename
 * Assumes filename follows pattern like "20240503_EXHIBIT-C1B_Shenandoah-Police-Call-Transcript.pdf"
 * 
 * @param {string} filename - File name to parse
 * @returns {string} Exhibit ID or empty string
 */
export const getExhibitIdFromFilename = (filename) => {
  if (!filename) return '';
  
  // Try to match pattern like EXHIBIT-C1B or Exhibit-D13
  const match = filename.match(/EXHIBIT[-_]([A-Z0-9]+)/i);
  
  return match ? match[1] : '';
};

export default {
  openPdfInNewWindow,
  doesFileExist,
  getFileNameFromPath,
  getExhibitIdFromFilename
};